module.exports = __webpack_public_path__ + "img/quote.jpg?98d021db6ab9ae726c5236b3e126db1e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/social/quote.jpg
// module id = 307
// module chunks = 0